
import { defineComponent, ref } from 'vue'
import recherchevehicule from "@/services/recherche_page.services"

export default defineComponent({
  name: 'checkBox',
  isChecked: Boolean,
  props: {
    id: String,
    group: String,
    name: String,
    total: Number,
    value: String
  },
  data () {
    return {
      isChecked: Boolean(this.isChecked || false)
    }
  },
  methods: {
    toggleClass: function () {
      this.isChecked = !this.isChecked;
    }
  },
  mounted() {
    // Initialisation de la sélection
    this.isChecked = recherchevehicule.isChecked(this.group, this.value);
  }
})
